import { Component, Injector, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { AppComponentBase } from "@shared/app-component-base";
import { ConsultaDto, ConsultaServiceProxy } from "@shared/service-proxies/service-proxies";
import { finalize } from "@node_modules/rxjs/internal/operators/finalize";
import { LayoutStoreService } from "@shared/layout/layout-store.service";

@Component({
    selector: 'default-consulta',
    templateUrl: './default-consulta.component.html',
    styleUrls: ['./default-consulta.component.scss']
})
export class DefaultConsultaComponent extends AppComponentBase implements OnInit, OnDestroy {
    protected subscriptions: Subscription[] = [];
    protected consulta: ConsultaDto;

    constructor(
        public injector: Injector,
        private readonly consultaService: ConsultaServiceProxy,
        private readonly route: ActivatedRoute,
        private readonly layoutStore: LayoutStoreService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.subscriptions.push(this.getConsulta(params["id"]));
        })
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    private getConsulta(id: string): Subscription {
        return this.consultaService
            .get(id)
            .pipe(
                finalize(() => {
                    abp.ui.clearBusy();
                })
            )
            .subscribe((result: ConsultaDto) => {
                this.consulta = result;
            });
    }
}
